import { Directive, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { StorageService } from '../services/storage.service';

@Directive({
  standalone: true,
  selector: '[mableSessionDismissibleButton]',
})
export class SessionDismissibleButtonDirective implements OnInit {
  // This directive is currently used on two types of component: Banner and Info Tile.
  @Input() bannerId;

  // @Input() sessionDismissable = false;

  @Output() onVisibilityToggle = new EventEmitter();

  constructor(
    // private elementRef: ElementRef,
    // private renderer: Renderer2,
    private storage: StorageService,
  ) {}

  // Upon click, checks the type of the component this directive is being applied to.
  @HostListener('click', ['$event'])
  onClick(event) {
    event.stopPropagation();
    if (!this.bannerId) {
      // Directly broadcast visibility for non-banners.
      this.broadcastVisibility();
    } else {
      this.storeThenRemoveVisibility();
    }
  }

  ngOnInit() {
    this.loadVisibilityStatus();
  }

  // add/modify item in storage, then hide.
  storeThenRemoveVisibility() {
    this.storage.set(this.bannerId, true);
    this.broadcastVisibility();
  }

  // Allows components for customized behavior by listening to onVisibilityToggle.
  broadcastVisibility(display = false) {
    this.onVisibilityToggle.emit(display);
  }

  // Checks the storage for an available item then displays.
  loadVisibilityStatus() {
    this.storage.ready().then(() =>
      this.storage.get(this.bannerId).then((banner) => {
        this.broadcastVisibility(!banner);
      }),
    );
  }
}
